export const LOGIN_BEGIN = 'LOGIN_BEGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const SEND_TOKEN_BEGIN = 'SEND_TOKEN_BEGIN'
export const SEND_TOKEN_SUCCESS = 'SEND_TOKEN_SUCCESS'
export const SEND_TOKEN_FAILURE = 'SEND_TOKEN_FAILURE'

export const LOGOUT = 'LOGOUT'

export const RESET = 'RESET'

export const RESET_TOKEN = 'RESET_TOKEN'

export const LOAN_APPLY_BEGIN = 'LOAN_APPLY_BEGIN'
export const LOAN_APPLY_SUCCESS = 'LOAN_APPLY_SUCCESS'
export const LOAN_APPLY_FAILURE = 'LOAN_APPLY_FAILURE'
export const LOAN_APPLY_RESET = 'LOAN_APPLY_RESET'

export const GET_USERDETAILS_BEGIN = 'GET_USERDETAILS_BEGIN'
export const GET_USERDETAILS_SUCCESS = 'GET_USERDETAILS_SUCCESS'
export const GET_USERDETAILS_FAILURE = 'GET_USERDETAILS_FAILURE'
export const GET_USERDETAILS_RESET = 'GET_USERDETAILS_RESET'

export const GET_PENDING_LOANS_BEGIN = 'GET_PENDING_LOANS_BEGIN';
export const GET_PENDING_LOANS_SUCCESS = 'GET_PENDING_LOANS_SUCCESS';
export const GET_PENDING_LOANS_FAILURE = 'GET_PENDING_LOANS_FAILURE';
export const GET_PENDING_LOANS_RESET = 'GET_PENDING_LOANS_RESET';

export const POST_LOAN_STATUS_BEGIN = 'POST_LOAN_STATUS_BEGIN';
export const POST_LOAN_STATUS_SUCCESS = 'POST_LOAN_STATUS_SUCCESS';
export const POST_LOAN_STATUS_FAILURE = 'POST_LOAN_STATUS_FAILURE';
export const POST_LOAN_STATUS_RESET = 'POST_LOAN_STATUS_RESET';

export const GET_LOAN_HISTORY_BEGIN = 'GET_LOAN_HISTORY_BEGIN';
export const GET_LOAN_HISTORY_SUCCESS = 'GET_LOAN_HISTORY_SUCCESS';
export const GET_LOAN_HISTORY_FAILURE = 'GET_LOAN_HISTORY_FAILURE';
export const GET_LOAN_HISTORY_RESET = 'GET_LOAN_HISTORY_RESET';

export const SEND_LOAN_ACCEPTANCE_BEGIN = 'SEND_LOAN_ACCEPTANCE_BEGIN';
export const SEND_LOAN_ACCEPTANCE_SUCCESS = 'SEND_LOAN_ACCEPTANCE_SUCCESS';
export const SEND_LOAN_ACCEPTANCE_FAILURE = 'SEND_LOAN_ACCEPTANCE_FAILURE';
export const SEND_LOAN_ACCEPTANCE_RESET = 'SEND_LOAN_ACCEPTANCE_RESET';

export const SEND_OTP_BEGIN = 'SEND_OTP_BEGIN';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_FAILURE = 'SEND_OTP_FAILURE';
export const SEND_OTP_RESET = 'SEND_OTP_RESET';

export const SEND_VENDOR_DETAILS_BEGIN = 'SEND_VENDOR_DETAILS_BEGIN';
export const SEND_VENDOR_DETAILS_SUCCESS = 'SEND_VENDOR_DETAILS_SUCCESS';
export const SEND_VENDOR_DETAILS_FAILURE = 'SEND_VENDOR_DETAILS_FAILURE';
export const SEND_VENDOR_DETAILS_RESET = 'SEND_VENDOR_DETAILS_RESET';